import i18n from "i18next";
import { tKeyToCanonical } from "./labelRegistry";

/**
 * devolve: rótulo alternativo (se houver) OU t(original)
 */
export function getAltLabel(tKey, userDetails, t = i18n.t) {
  const canonical = tKeyToCanonical[tKey]; // ex.: "branch"
  const lang = i18n.language?.slice(0, 2) || "en";

  const alt =
    canonical && userDetails?.fields_alternative_names?.[canonical]?.[lang];

  return alt && alt.trim() !== "" ? alt : t(tKey);
}
